import type { GlobalToken } from 'antd'

import type { PillTone } from './types'

/**
 * Named tones are antd Tag presets, which keep their text readable. Config
 * colors can be anything, so they become a dot on a plain pill rather than a
 * fill that might hide the label.
 */
export function resolvePillTone(tone: PillTone | undefined): {
  tagColor?: string
  dotColor?: string
} {
  if (!tone) return {}
  if (typeof tone === 'string') return { tagColor: tone }
  return { dotColor: tone.color }
}

/** A solid colour for a tone, for surfaces larger than a pill (e.g. board column headers). `default` has none. */
export function resolveToneColor(
  tone: PillTone | undefined,
  token: GlobalToken
): string | undefined {
  if (!tone || tone === 'default') return undefined
  if (typeof tone !== 'string') return tone.color
  const colors = {
    processing: token.colorInfo,
    success: token.colorSuccess,
    warning: token.colorWarning,
    error: token.colorError,
  }
  return colors[tone]
}
